// import FourImageRow from "../components/gallery/FourImageRow";
import ImageGrid from "../components/gallery/ImageGrid";
import InfinitePhotoScroll from "../components/gallery/InfinitePhotoScroll";

const Gallery = () => {
  return (
    <div className="flex flex-col gap-6 xl:mx-28 mx-5 my-20">
      <h1 className="text-4xl font-bold text-center mb-24">Photo Gallery</h1>
      <InfinitePhotoScroll />
      <ImageGrid />
      {/* <FourImageRow /> */}
      {/* <ImageGrid /> */}
    </div>
  );
};
export default Gallery;
